import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=4c9b8466&scoped=true&"
import script from "./HistoryRecord.vue?vue&type=script&lang=js&"
export * from "./HistoryRecord.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRecord.vue?vue&type=style&index=0&id=4c9b8466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b8466",
  null
  
)

export default component.exports